import './polyfill';
import './localisation';
import './utils/ckeditor-loader';

import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import VueLazyLoad from 'vue-lazyload';
import BootstrapVue from 'bootstrap-vue';
import VueQrcode from '@chenfengyuan/vue-qrcode';
// eslint-disable-next-line import/extensions
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap';
import VueSelect from 'vue-select';
import * as Logger from 'js-logger';

import Config from './config.json';

import * as Store from './store';

import router from './router';

import AdminLayout from './components/layout/layout.vue';

// Styles and fonts
import '../node_modules/font-awesome/css/font-awesome.min.css';
import 'vue-select/dist/vue-select.css';

import template from './main.vue';

import WebsocketClient, { WebsocketsListener } from './utils/ws';
import { PhoneValidation } from './utils/phone-validation';

const logLevel = Config.debug ? Logger.DEBUG : Logger.ERROR;
Logger.useDefaults();
Logger.setLevel(logLevel);

Vue.use(VueLazyLoad);
Vue.use(BootstrapVue);

Vue.component('v-select', VueSelect);
Vue.component(VueQrcode.name, VueQrcode);

// Global registration
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap);

// Telefon user cu prefix: {{ user | phone }}
Vue.filter('phone', (user: any) => PhoneValidation.format(user));

Vue.config.productionTip = false;

Vue.config.errorHandler = (err: Error) => {
    Logger.error('Vue error: ', err);
};

// Init websocket client
new WebsocketClient();

@Component({
    mixins: [template],
    store: Store.store,
    components: {
        AdminLayout,
    },
    router,
})
class App extends Vue {
    isAdmin: boolean = false;
    isPhotographer: boolean = false;
    wsListener: WebsocketsListener;

    constructor() {
        super();
        this.wsListener = new WebsocketsListener();
    }

    mounted() {
        // Assign session values to store for global dispatch
        this.wsListener.onGet('wss.session', (success: boolean, data: any) => {
            if (success) {
                this.wsListener.setAuthState(success, data);

                Store.commitLoggedInUser(this.$store, data);
                Store.commitLoggedInState(this.$store, true);

                this.isAdmin = data.isAdmin;
                this.isPhotographer = data.isPhotographer;
            }

            Store.commitCheckingSession(this.$store, false);
        });
    }

    isCheckingSession() {
        return Store.readCheckingSession(this.$store);
    }

    isLoggedIn() {
        return Store.readLoggedInState(this.$store);
    }

    hasLoaderActive() {
        return Store.readLoaderVisibility(this.$store);
    }
}

window.onerror = (errorMsg: string | Event) => {
    Logger.error('Global event: ', errorMsg);
    Store.commitLoaderVisibility(Store.store, false);
};

export const app = new App().$mount('#app');



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/main.ts